import { FolderOpenDot } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const SubstantiationReviewStatusFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const statusOptions: ComboboxFilterOption<string>[] = [
    { label: 'Waiting for Review', value: 'waiting_for_review' },
    { label: 'Approved', value: 'approved' },
    { label: 'Rejected', value: 'rejected' },
    { label: 'Inactive', value: 'inactive' },
  ]

  const filteredOptions = statusOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Review Status', options: filteredOptions || [] }]}
        placeholder='Search review statuses to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={statusOptions || []}
          noSelectionText='Review Status'
          pluralIdentifier='review statuses'
        >
          <FolderOpenDot size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default SubstantiationReviewStatusFilter
